
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/[uuid]",
      function () {
        return require("private-next-pages/form/[uuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/[uuid]"])
      });
    }
  